import { graphql } from 'react-relay';

export const fundsListDownloadFragment = graphql`
    fragment FundsListDownload_fundsListDownload on SimpleLink {
        label
        url
    }
`;
